import React, { useEffect } from 'react'
import './style.sass'

import { Header } from 'pages/Header'
import { Footer } from 'pages/Footer'
import Error from 'components/Error/ErrorProduct'

export default function Error404 () {

    //- Codigo de instana para track de pagina 
    useEffect(()=>{
        window.ineum('page', 'Error 404 Credit-Page')
        window.ineum('meta', 'portal', 'Credito')
    },[])

    return(
        <>
            <Header type="complete"/>
            <main>
                <section>
                    <div className="errorPage">
                        <Error />
                    </div>
                </section>
            </main>
            <Footer type="complete"/>
        </>
    )
}